import { render, staticRenderFns } from "./Multiplexing.vue?vue&type=template&id=624b2bfa&"
import script from "./Multiplexing.vue?vue&type=script&lang=js&"
export * from "./Multiplexing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports